$('.shop-type-tablist').each(function(){
    var $container = $(this); 

    $container.find('li').click(function(){
        $container.find('li').removeClass('selected');
        $(this).addClass('selected');
        console.log();
        var tab_data = $(this).attr('data-tab');
        $('.tab-content[data-tab-label="'+ $container.attr('data-tab-label') +'"]').css('display','none');
        $('.tab-content[data-tab-label="'+ $container.attr('data-tab-label') +'"][data-tab="'+ tab_data +'"]').css('display','grid');
    });
});